module.exports = __webpack_public_path__ + "cement/img/图层 3.b828b143.png";